<script>
  import {beforeUpdate} from "svelte"
  import Progress from "../shared/progress.svelte"
  export let password = ""
  let score = 0

  beforeUpdate(()=>{
    score = strength(password)
  })

  const checkRepetition = (rLen, str)=>{
    var res = "", repeated = false;
    for (var i = 0; i < str.length; i++) {
      repeated = true;
      for (var j = 0; j < rLen && (j + i + rLen) < str.length; j++) {
        repeated = repeated && (str.charAt(j + i) === str.charAt(j + i + rLen));
      }
      if (j < rLen) {
        repeated = false;
      }
      if (repeated) {
        i += rLen - 1;
        repeated = false;
      } else {
        res += str.charAt(i);
      }
    }
    return res;
  }

  const strength = (password)=>{
    let score = 0
    if (password.match(/password/)){return score}
    if (password.match(/1234/)){return score}
    score += password.length * 6;
    score += checkRepetition(1, password).length - password.length
    score += checkRepetition(2, password).length - password.length
    score += checkRepetition(3, password).length - password.length
    score += checkRepetition(4, password).length - password.length
    if (password.match(/(.*[0-9].*[0-9].*[0-9])/)) { score += 5 } // password has 3 numbers
    if (password.match(/[^\w\s]/g) && password.match(/[^\w\s]/g).length > 0) { score += 5;} // password has at least 2 sybols (not space or letters)
    if (password.match(/[a-z]/) && password.match(/[A-Z]/)) { score += 10 } // password has Upper and Lower chars
    if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)) { score += 15 } // password has number and chars
    if (password.match(/[^\w\s]/) && password.match(/[0-9]/)) { score += 15 } // password has number and symbol
    if (password.match(/[^\w\s]/) && password.match(/([a-zA-Z])/)) { score += 15 } // password has char and symbol
    if (password.match(/^\w+$/) || password.match(/^\d+$/)) { score -= 10 } // password is just numbers or chars
    if (score > 100) { score = 100 }
    if (score < 0) { score = 0 }
    return score;
  }

</script>

<Progress mode={score > 80 ? 'success' : score > 50 ? 'warning' : 'danger' } value={score}>
  {score > 80 ? 'stronger' : score > 50 ? 'strong' : 'weak' }
</Progress>